module.exports = __webpack_public_path__ + "static/media/children3.4b6d77a9.jpg";